// 统一渲染入口：按 format 路由到 markdown / html 管线
//   md：renderMarkdown → 字符串 HTML → innerHTML 注入
//   html：mountHtmlIframe → 创建 sandbox iframe（隔离 CSS/JS/DOM）
import { renderMarkdown } from './markdown';
import { mountHtmlIframe } from './render-html';
import type { ResumeFormat } from './types';

export function renderInto(
  container: HTMLElement,
  content: string,
  format: ResumeFormat,
): void {
  if (format === 'html') {
    mountHtmlIframe(container, content);
    return;
  }
  container.innerHTML = renderMarkdown(content);
}
